export default "__VITE_ASSET__S$CVSKq1__"